import { z } from 'zod';

export type User = {
  email: string;
  email_verified: boolean;
  name: string;
  nickname: string;
  picture: string;
  sub: string;
  updated_at: string;
};

export interface UserProfile {
  user_preferences: {
    preferred_language: string;
    preferred_language_status?: string;
  };
  user_flags: {
    preferred_language_informed: boolean;
    onboarding_informed: boolean;
  };
  user_data: {
    student_info?: {
      school: string;
      major: string;
      graduation_year: number;
    };
    activity_types?: string[];
  };
}

export const EditZocSchema = z.object({
  title: z.string().min(1, { message: 'Title is required' }),
  class_name: z.string(),
});

export type EditZocInputs = z.infer<typeof EditZocSchema>;

export enum ZocStatus {
  pending = 'pending',
  user_error = 'error',
  progress = 'pending', // progress status is handled as pending one
  done = 'done',
  error = 'error',
  draft = 'draft',
}
export enum RECORDING_EVENTS {
  ON_RECORDING_CREATED = 'onRecordingCreated',
  ON_RECORDING_PROCESSING_DONE = 'onRecordingProcessingDone',
  ON_RECORDING_STOPPED_FORCED = 'onRecordingStoppedForced',
  ON_RECORDING_DISCARDED = 'onRecordingDiscarded',
}

export interface TextItem {
  text: string;
  start: number;
  end: number;
}

export interface TranscriptItem {
  language: string;
  paragraphs: TextItem[];
  words: TextItem[];
}

export interface Transcript {
  chunk_number: number;
  processing: TranscriptItem;
  final: TranscriptItem;
}

export interface ZocRecording {
  data: ArrayBuffer;
  type: string;
  chunkNumber: number;
  zocRecordingId: string;
  createdAt: number;
  isStopped?: boolean;
}

export interface ZocRecordingProcessedEvent {
  recording: ZocRecording;
  transcript: Transcript;
}

export interface Language {
  code: string;
  name: string;
}

export type SubscriptionPlanType = 'b2b' | 'b2c' | 'free';

export type SubscriptionPlanStatus = 'active' | 'inactive' | 'error';

export interface SubscriptionPlan {
  type: SubscriptionPlanType;
  name: string;
  tagline: string;
  features: string[];
  start_date: string;
  expires_date: string;
  renewal_date: string;
  management_url: string;
  status: SubscriptionPlanStatus;
}

export interface Quota {
  remaining_zoc: number | null;
}

export interface UserSubscription {
  subscription_plan: SubscriptionPlan;
  entitlements: string[];
  quota: Quota;
}

export type AppStoreKind = 'apple' | 'android' | 'other';
export interface StoreInfo {
  name: string;
  logo: any;
  link: string;
}
